import { CpmChip } from '../../../components/design-system';
import { REPORTS_COPY } from '../copy';

export interface AppliedChip {
    key: string;
    label: string;
    onClear: () => void;
}

export default function AppliedFilterChips({
    chips,
    onClearAll,
}: {
    chips: AppliedChip[];
    onClearAll: () => void;
}) {
    if (chips.length === 0) return null;
    return (
        <div
            className="flex flex-wrap items-center"
            style={{
                gap: 8,
                marginTop: 12,
                padding: '10px 12px',
                border: '1px solid var(--cpm-border-default)',
                borderRadius: 10,
                background: 'var(--cpm-surface-subtle)',
            }}
        >
            {chips.map((chip) => (
                <CpmChip key={chip.key} variant="token" onRemove={chip.onClear}>
                    {chip.label}
                </CpmChip>
            ))}
            <button
                type="button"
                onClick={onClearAll}
                className="bg-transparent border-0 cursor-pointer"
                style={{
                    fontSize: 12,
                    fontWeight: 800,
                    color: 'var(--cpm-brand-purple)',
                }}
            >
                {REPORTS_COPY.CLEAR_FILTERS}
            </button>
        </div>
    );
}
